import * as React from 'react';
import { Menu } from '../menu/Menu';
import { MenuItem } from '../menu/MenuItem';
import { useAuth } from '@mc/react-auth';
import { NAVBAR_USER_MENU } from '../common/classes';
import { useHistory } from 'react-router';
import { useAppConfig } from '@mc/react-app-base';
import { NavbarButton } from '../button/NavbarButton';
import { Classes, Icon, MenuDivider } from '../index';
import classNames from 'classnames';
import { mcLogout, mcSettings } from '@mc/react-ui-icons';

export type UserMenuProps = {
  /**
   * Položky v menu pod uživatelem (kliknutí na jméno přihlášeného uživatele).
   */
  items?: React.ReactNode[];
  /**
   * Položky v menu pod otazníčkem.
   */
  helpItems?: React.ReactNode[];
  /**
   * Skrytí položky Nastavení.
   */
  hideConfMenuItem?: boolean;
  /**
   * Skrytí položky Nápověda.
   */
  hideNapovedaMenuItem?: boolean;
  /**
   * Skrytí položky Odhlásit.
   */
  hideLogoutMenuItem?: boolean;
  /**
   * Skrytí tlačítka Přihlásit.
   */
  hideLoginButton?: boolean;
};

export const UserMenu: React.FC<UserMenuProps> = ({
  items,
  hideConfMenuItem,
  hideLogoutMenuItem,
  hideLoginButton,
}) => {
  const auth = useAuth();
  const history = useHistory();
  const appConfig = useAppConfig();
  const prihlasit = () => {
    history.push('/login');
  };
  const getInitials = (
    firstname: string | undefined,
    surname: string | undefined
  ): string | undefined => {
    if (!firstname && !surname) return undefined;
    const initialJmeno =
      firstname && firstname.length > 0 ? firstname[0].toUpperCase() : '';
    const initialPrijmeni =
      surname && surname.length > 0 ? surname[0].toUpperCase() : '';

    return initialJmeno + initialPrijmeni;
  };

  const getFullname = () => {
    const arr: string[] = [];
    // @ts-ignore
    if (auth.data?.firstname) {
      // @ts-ignore
      arr.push(auth.data.firstname);
    }
    // @ts-ignore
    if (auth.data?.surname) {
      // @ts-ignore
      arr.push(auth.data.surname);
    }
    return arr.join(' ');
  };

  const openConf = React.useCallback(() => {
    window.open(`${appConfig.serverContextPath}/conf`, '_blank');
  }, [auth.data]);
  if (auth?.isLoggedIn) {
    const initials = getInitials(auth.data?.firstname, auth.data?.surname);
    const fullname = getFullname();
    const hideMenu =
      (!items || items.length < 1) && hideConfMenuItem && hideLogoutMenuItem;
    return (
      <div className={NAVBAR_USER_MENU}>
        <NavbarButton
          title={fullname}
          disabled={hideMenu}
          hideMenuDropdownIcon
          className={classNames({
            [Classes.NAVBAR_USER_MENU_BUTTON]: initials,
          })}
          menu={
            <Menu>
              {fullname && <MenuDivider title={fullname} />}
              {items}
              {!hideConfMenuItem && (
                <MenuItem
                  onClick={openConf}
                  icon={<Icon icon={mcSettings} />}
                  text={'Nastavení'}
                />
              )}
              {!hideLogoutMenuItem && (
                <MenuItem
                  onClick={() => auth.logout()}
                  icon={<Icon icon={mcLogout} />}
                  text={'Odhlásit'}
                />
              )}
            </Menu>
          }
        >
          {initials ? initials : auth.data?.fullname}
        </NavbarButton>
      </div>
    );
  } else {
    if (hideLoginButton) return null;
    return <NavbarButton onClick={prihlasit}>Přihlásit</NavbarButton>;
  }
};
